import { createFileRoute } from "@tanstack/react-router";
import { RoofingServicePage } from "@/components/RoofingServicePage";
import { solarRepairPages } from "@/data/solarRepairContent";

export const Route = createFileRoute("/services/solar-repair")({
  head: () => ({
    meta: [
      { title: "Solar Repair in Southern California - McKay Roofing & Solar" },
      { name: "description", content: "Solar repair and diagnostics across Southern California. Inverter replacement with manufacturer warranty and ongoing service." },
      { property: "og:title", content: "Solar Repair in Southern California - McKay Roofing & Solar" },
      { property: "og:description", content: "Solar repair and diagnostics across Southern California. Inverter replacement with manufacturer warranty and ongoing service." },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mckay.steadyautogrowthdemo.com/services/solar-repair" }],
  }),
  component: () => <RoofingServicePage {...solarRepairPages["solar-repair"]} />,
});
